import React, { useState,useEffect } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from 'sweetalert';
import { ClipLoader } from "react-spinners";
import Pagination from "../components/Pagination";

const CourseCategories = () => {
    
    const authToken = localStorage.getItem("token");
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
    });
    
    const [loading, setLoading] = useState(true);
     // Fetch categories from the server

    const fetchCategories = async (page = 1) => {
      try {
        setLoading(true);
        
        const response = await axios.post(API_URLS.COURSES_CATEGORIES+`?page=${page}`,null, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        console.log(response.data);
        if(response.data.success==1){
        setCategories(response.data.listData.data);
        setPagination({
          current_page: response.data.listData.current_page,
          last_page: response.data.listData.last_page,
          per_page: response.data.listData.per_page,
          total: response.data.listData.total,
        });
        }else{
        swal("Error", response.data.message, "error");  
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchCategories();
  }, []);
 

  // Change page
  const handlePageChange = (page) => {
    fetchCategories(page);
  };

  const handleEdit = (category) => {
    navigate('/manager/course-category/add', { state: { category } }); // Pass category data to the form page
  };

  const handleDelete = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete this record?")) {
      
         const response = await axios.post(API_URLS.COURSES_CATEGORY_DELETE+`?id=${id}`,null, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
      
        if(response.data.success==1){
          swal("Success", response.data.message, "success").then(() => {
            fetchCategories(pagination.current_page); // Refresh the list after deletion
          });
         
          }else{
          swal("Error", response.data.message, "error");  
          }
          
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      
      swal("Error", "Failed, Please try again.", "error");  
     
    }
  };
    return (
     <>
       {loading && (
                             <div className="loader-overlay">
                                 <ClipLoader color="#08A9E6" loading={loading} size={50} />
                             </div>
                         )}
         <div className="container mt-5">
      <h2 className="mb-4 float-start">Category List</h2>
      <Link to="/manager/course-category/add" className="btn btn-primary float-end mb-2">Add Category</Link>
      <table className="table table-bordered table-hover">
        <thead className="table-primary">
          <tr>
            <th style={{width:"10%"}}>#</th>
            <th style={{width:"80%"}}>Category Name</th>
            <th style={{width:"10%"}}>Action</th>
          </tr>
        </thead>
        <tbody>
          {categories.length > 0 ? (
            categories.map((listItem, index) => (
              <tr key={listItem.id}>
                <td>{(pagination.current_page-1)*pagination.per_page+index + 1}.</td>
                <td>{listItem.category}</td>
                <td>
                  <span  className="cursor-pointer" onClick={() => handleEdit(listItem)}><i className="fa fa-pencil"></i></span>
                  
                  <span  className="cursor-pointer" onClick={() => handleDelete(listItem.id)} className="ms-2"><i className="fa fa-trash"></i></span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-center">
                No categories available
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {/* Pagination Component */}
      {pagination.last_page > 1 && (
      <Pagination
            currentPage={pagination.current_page}
            lastPage={pagination.last_page}
            onPageChange={handlePageChange}
          />)}
    </div>
     </>);
}
export default CourseCategories;